
/**
 * 退款申请弹框
 */
import React, { Component } from 'react';
import { Modal, Form, Input,Button } from 'antd';

import http from '../../../axios/http';
import messager from '../../ui/messager';

const fields = [{
    "text": "备注",
    "field": "remark",
    "textarea": true,
}];

class PayOrderApprovalForm extends Component {
    state = {
        visible: false
    }
    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            let orderId = this.props.editData
            if (orderId !== undefined && orderId != null) {
                values["orderId"] = orderId;
            }
            values["type"] = "APPROVED";
            http.post({
                url: '/payOrder/approvalRefund',
                data: values,
                success: () => {
                    this.props.successCallback(this.props.queryData);
                    this.props.onCancel();
                    messager.notify("退款申请成功！");
                }
            });
        });
    };

    reject = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            let orderId = this.props.editData
            if (orderId !== undefined && orderId != null) {
                values["orderId"] = orderId;
            }
            values["type"] = "REJECT";
            http.post({
                url: '/payOrder/approvalRefund',
                data: values,
                success: () => {
                    this.props.successCallback(this.props.queryData);
                    this.props.onCancel();
                    messager.notify("退款申请成功！");
                }
            });
        });
    };

    fun1 = () => {
        console.log("1")
    };

    createDom = (data) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let itemDom = (
                <Form.Item key={i} label={item.text + "："}>
                    {
                        getFieldDecorator(item.field, {
                            rules: item.rules,
                            initialValue: editData[item.field],
                        })(
                            item.textarea ? <Input.TextArea />
                                    : <Input />
                        )
                    }
                </Form.Item>
            );
            dom.push(itemDom);
        }
        return dom;
    };


    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                width={500}
                visible={visible}
                title="退款审批"
                maskClosable={false}
                onCancel={onCancel}
                afterClose={() => { this.props.form.resetFields() }}
                footer={[
                    <Button key="apply" type="danger" onClick={this.reject}>退回</Button>,
                    <Button key="apply" type="primary" onClick={this.save}>同意</Button>,
                    <Button key="close" type="default"  onClick={onCancel}>关闭</Button>,
                ]}
            >
                <Form layout="vertical" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                    {this.createDom(fields)}
                </Form>
            </Modal>
        );
    }
}

const PayOrderApprovalFormEdit = Form.create()(PayOrderApprovalForm);

export default PayOrderApprovalFormEdit;